import {
    CREATE_AREA_MASTER_FAILURE,
    CREATE_AREA_MASTER_REQUEST,
    CREATE_AREA_MASTER_SUCCESS,
    CREATE_USER_FORM_AREA_MASTER,
    DELETE_AREA_MASTER_FAILURE,
    DELETE_AREA_MASTER_REQUEST,
    DELETE_AREA_MASTER_SUCCESS,
    FETCH_AREA_MASTER_FAILURE,
    FETCH_AREA_MASTER_REQUEST,
    FETCH_AREA_MASTER_SUCCESS,
    FETCH_SINGLE_AREA_MASTER_FAILURE,
    FETCH_SINGLE_AREA_MASTER_REQUEST,
    FETCH_SINGLE_AREA_MASTER_SUCCESS,
    RESET_USER_ADDRESS_INFO,
    UPDATE_AREA_MASTER_FAILURE,
    UPDATE_AREA_MASTER_REQUEST,
    UPDATE_AREA_MASTER_SUCCESS,
    USER_ADDRESS_INFO_FAILURE,
    USER_ADDRESS_INFO_REQUEST,
    USER_ADDRESS_INFO_SUCCESS,
    USER_STATE_LIST_REQUEST,
    USER_STATE_LIST_SUCCESS
} from './areaMaster.actionsType';

export const AREA_MASTER = 'areaMaster';

let initialState = {
    loading: false,
    areaMaster: [],
    countryList: null,
    stateList: null,
    cityList: null,
    areaList: null,
    pincodeList: null,
    userform: {},
    selectedArea: null,
    errorMessage: '',
    iperrorMessage: ''
};

export let companyAreaReducer = (state = initialState, action) => {
    let { type, updatePayload, payload } = action;

    switch (type) {
        case FETCH_AREA_MASTER_REQUEST:
        case USER_ADDRESS_INFO_REQUEST:
        case CREATE_AREA_MASTER_REQUEST:
        case USER_STATE_LIST_REQUEST:
        case FETCH_SINGLE_AREA_MASTER_REQUEST:
        case UPDATE_AREA_MASTER_REQUEST:
        case DELETE_AREA_MASTER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_AREA_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                areaMaster: updatePayload
            };
        case RESET_USER_ADDRESS_INFO:
            return {
                ...state,
                userform: {},
                selectedArea: {}
            };
        case USER_ADDRESS_INFO_SUCCESS:
            if (payload == 29) {
                return {
                    ...state,
                    loading: false,
                    countryList: updatePayload
                };
            } else if (payload == 3) {
                return {
                    ...state,
                    loading: false,
                    cityList: updatePayload
                };
            } else if (payload == 2) {
                return {
                    ...state,
                    loading: false,
                    areaList: updatePayload
                };
            } else if (payload == 4) {
                return {
                    ...state,
                    loading: false,
                    pincodeList: updatePayload
                };
            } else {
                return {
                    ...state,
                    loading: false
                };
            }
        case USER_STATE_LIST_SUCCESS: {
            return {
                ...state,
                loading: false,
                stateList: updatePayload
            };
        }
        case CREATE_AREA_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {}
            };
        case FETCH_SINGLE_AREA_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedArea: updatePayload,
                userform: {
                    country: {
                        fldDescription: updatePayload.fldCountry,
                        fldId: updatePayload.fldFKCountry
                    },
                    state: {
                        fldDescription: updatePayload.fldState,
                        fldId: updatePayload.fldFKState
                    },
                    city: {
                        fldDescription: updatePayload.fldCity,
                        fldId: updatePayload.fldFKCity
                    },
                    pincode: {
                        fldDescription: updatePayload.fldPincode,
                        fldId: updatePayload.fldFKPincode
                    },
                    area: {
                        fldDescription: updatePayload.fldArea,
                        fldId: updatePayload.fldFKArea
                    }
                }
            };
        case UPDATE_AREA_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {},
                selectedArea: {},
                countryList: null,
                stateList: null,
                cityList: null,
                areaList: null,
                pincodeList: null
            };
        case DELETE_AREA_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                countryList: null,
                stateList: null,
                cityList: null,
                areaList: null,
                pincodeList: null,
                userform: {}
            };
        case FETCH_AREA_MASTER_FAILURE:
        case USER_ADDRESS_INFO_FAILURE:
        case CREATE_AREA_MASTER_FAILURE:
        case FETCH_SINGLE_AREA_MASTER_FAILURE:
        case UPDATE_AREA_MASTER_FAILURE:
        case DELETE_AREA_MASTER_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_AREA_MASTER:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [updatePayload.key]: updatePayload.value
                }
            };
        default:
            return state;
    }
};
